import React from 'react'

const ConfirmationOfVesselCompletionAndDelivery = () => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card" id={1}>
          <div className="card-body">
            <div className="checklist-title-bx">
              <div className="row">
                <div className="col-md-9">
                  <div className="text-left">
                    <h4>
                      Form # 2 - Confirmation of Vessel Completion and Delivery
                    </h4>
                    <p>
                      THIS IS TO CONFIRM that OneSea solutions Pte. Ltd., a
                      corporation organized and existing under the laws of
                      Singapore, having its registered office at 460 Alexandra Road,
                      #38-02 mTower, Singapore 119963, has successfully completed
                      the supervision of the vessel, with particulars given below,
                      with full compliance with the agreed Building Specifications,
                      and with all applicable Classification &amp; Statutory
                      certificates specified therein, do fulfil the requirements set
                      out in the Site Supervision
                    </p>
                  </div>
                </div>
                <div className="col-md-3">
                  <table className="table-bottom-sig table-top-sig">
                    <tbody>
                      <tr className="bottom-sig-tr2-box">
                        <td className="input-td">
                          <p className="s2">Date</p>
                        </td>
                        <td>
                          <p className="s1">
                            <input
                              type="text"
                              className="form-control"
                              placeholder=""
                              defaultValue=""
                            />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                  <table className="assessment-table" cellSpacing={0}>
                    <tbody>
                      <tr>
                        <td className="hd-s2 pd10">
                          {" "}
                          <p>S.No.</p>
                        </td>
                        <td className="hd-s2 pd10 w300">
                          <p>Enquiry Reference</p>
                        </td>
                        <td className="hd-s1 pd10">
                          <p />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">1.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>OSS Project</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">2.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Builder &amp; Hull no.</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">3.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Name of Owner</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">4.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Name of vessel</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">5.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Type of vesse</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">6.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Port of Registry</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">7.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Official number</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">8.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>classification</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">9.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Year Built</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">10.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Date of Keel-Laying</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">11.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Date of Launching</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">12.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Date of Delivery</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">13.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Side letter if any</p>
                        </td>
                        <td className="tb-input-value">
                          <input
                            type="text"
                            className="form-control"
                            placeholder=""
                            defaultValue=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="td-s1">
                          <p className="s1">14.</p>
                        </td>
                        <td className="tb-input-value pl10">
                          <p>Remarks (if any):</p>
                        </td>
                        <td className="tb-input-value">
                          <textarea defaultValue={""} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="row">
                    <div className="col-lg-12">
                      <table className="mrt20">
                        <tbody>
                          <tr>
                            <td className="hd-b">
                              <p>
                                IN WITNESS WHEREOF, OneSea solutions Pte. Ltd. has
                                hereby executed this declaration on
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td className="input-textarea">
                              <textarea defaultValue={""} />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <table className="mrt10">
                        <tbody>
                          <tr>
                            <td className="hd-b" colSpan={2}>
                              <p className="mb-3">OneSea solutions Pte. Ltd</p>
                              <p />
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td className="input-td w150">
                              <p className="s2">BY:</p>
                            </td>
                            <td>
                              <p className="s1">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  defaultValue=""
                                />
                              </p>
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td className="input-td w150">
                              <p className="s2">Name</p>
                            </td>
                            <td>
                              <p className="s1">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  defaultValue=""
                                />
                              </p>
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td colSpan={2} className="input-td">
                              <p className="s2 mt-4">Title: Site Manager</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col-lg-6">
                      <table className="mrt10">
                        <tbody>
                          <tr>
                            <td className="hd-b">
                              <p className="mb-3">&nbsp;</p>
                              <p />
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td className="input-td w150">
                              <p className="s2">BY:</p>
                            </td>
                            <td>
                              <p className="s1">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  defaultValue=""
                                />
                              </p>
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td className="input-td w150">
                              <p className="s2">Name</p>
                            </td>
                            <td>
                              <p className="s1">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  defaultValue=""
                                />
                              </p>
                            </td>
                          </tr>
                          <tr className="bottom-sig-tr2-box">
                            <td colSpan={2} className="input-td">
                              <p className="s2 mt-4">
                                Title: Head of Projects OSS/ New building
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row mt-4"></div>
                <div className="row mt-4">
                  <div className="col-lg-12 text-left ">
                    <a
                      href="ship-inspection-progress-list.php"
                      className="btn btn-success"
                      style={{
                        backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                        borderColor: "#2b5a7e"
                      }}
                    >
                      Submit
                    </a>
                    <button
                      type="reset"
                      className="btn btn-danger ms-3"
                      style={{
                        backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                        borderColor: "#2b5a7e"
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default ConfirmationOfVesselCompletionAndDelivery